import { useEffect, useMemo, useRef, useState } from 'react'
import { SwiperSlide, Swiper } from 'swiper/react'
import Close from '../../assets/close-onboarding.svg?react'
import ArrowLeftSlideShow from '../../assets/left-slideshow-arrow.svg?react'
import ArrowRightSlideShow from '../../assets/right-slideshow-arrow.svg?react'
import Logo from '../../assets/wiki_logo.svg?react'
import BottomNavigation from '../BottomNavigation'
import Topbar from './Topbar'
import { Navigation } from 'swiper/modules'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import Menu from './Menu'
import Legend from './Legend'
import Profile from '../../pages/Mobile/Profile'
import { useDonationContext } from '../../context/DonationContext'
import { getActiveGeocontext } from '../../utils'
import { Modal } from 'react-bootstrap'
import Credits from './Credits'

export function SlidesPresentazioneMobile({
  isFromPageWiki = false,
  setPresentazione,
}: {
  isFromPageWiki?: boolean
  setPresentazione: (presentazione: boolean) => void
}) {
  const [activeSlide, setActiveSlide] = useState<number>(0)
  const sliderRef = useRef<any>()
  const { t } = useTranslation()

  return (
    <div
      className="w-100 h-100"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 12,
        backgroundColor: 'rgba(0,0,0,0.6)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Swiper
        slidesPerView={1}
        onSlideChange={(swiper) => {
          setActiveSlide(swiper.activeIndex)
        }}
        className="position-relative"
        // className="h-100 w-100"
        onSwiper={(swiper) => {
          sliderRef.current = swiper
        }}
        modules={[Navigation]}
        spaceBetween={20}
        navigation
        onInit={(swiper) => {
          swiper.slideTo(activeSlide, 0)
        }}
        style={{
          height: '60%',
          width: '80%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: 'auto',
          marginBottom: 'auto',
          marginLeft: 'auto',
          marginRight: 'auto',
          //   backgroundColor: 'rgba(0,0,0,0.2)',
          //   zIndex: 12,
        }}
      >
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div>
                <Logo width={60} />
              </div>
              <div className="mt-4 TitleSlideMobile">{t('GENERIC_WLM')}</div>
              <div className="mt-5 SubtitleSlideMobile">
                {t('TUTORIAL_OPENING')}!
              </div>
              <div className="mt-4 text-tutorial-mobile">
                {t('TUTORIAL_010_ALL_TEXT')}
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="TitleSlideMobileWithBorder">
              {t('GENERIC_COUNTRY')}
            </div>
            <div className="mt-3 mb-3 text-tutorial-mobile">
              {t('TUTORIAL_020_ALL_TEXT')}
            </div>
            <div className="d-flex justify-content-center mt-5">
              <img
                height={150}
                src={'/slides/mobile/slide1-mobile.svg'}
                alt="Slide2"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="TitleSlideMobileWithBorder">
              {t('TUTORIAL_030_ALL_TITLE')}
            </div>
            <div className="mt-3 mb-3 text-tutorial-mobile">
              {t('TUTORIAL_030_ALL_TEXT')}
            </div>
            <div className="mt-1 text-tutorial-mobile mb-2 ">
              {t('TUTORIAL_030_ALL_TEXT_2')}
            </div>
            <div className="d-flex justify-content-center mt-5">
              <img
                height={150}
                src={'/slides/mobile/slide2-mobile.svg'}
                alt="Slide2"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="TitleSlideMobileWithBorder">{t('MPL_BOX_MAP')}</div>
            <div className="mt-3 mb-3 text-tutorial-mobile">
              {t('TUTORIAL_040_ALL_TEXT')}
            </div>
            <div className='mt-1 text-tutorial-mobile mb-2'>
              {t('TUTORIAL_040_ALL_TEXT_2')}
            </div>
            <div className="d-flex justify-content-center mt-2">
              <img
                height={150}
                src={'/slides/mobile/slide3-mobile.svg'}
                alt="Slide2"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="TitleSlideMobileWithBorder">
              {t('TUTORIAL_050_ALL_TITLE')}
            </div>
            <div className="mt-3 mb-3 text-tutorial-mobile">
              {t('TUTORIAL_050_ALL_TEXT')}
            </div>
            <div className="d-flex justify-content-center mt-5">
              <img
                height={150}
                src={'/slides/mobile/slide4-mobile.svg'}
                alt="Slide2"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="TitleSlideMobileWithBorder">
              {t('GENERIC_LEGEND')}
            </div>
            <div className="mt-3 text-tutorial-mobile">
              {t('TUTORIAL_060_MOB_TEXT')}
            </div>
            <div className="mt-1 text-tutorial-mobile mb-2">
              {t('TUTORIAL_060_MOB_TEXT_2')}
            </div>
            <div className="d-flex justify-content-center mt-2">
              <img
                height={150}
                src={'/slides/mobile/slide5-mobile.svg'}
                alt="Slide2"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="TitleSlideMobileWithBorder">
              {t('TUTORIAL_070_MOB_TITLE')}
            </div>
            <div className="mt-3 text-tutorial-mobile">
              {t('TUTORIAL_070_MOB_TEXT')}
            </div>
            <div className="mt-1 text-tutorial-mobile mb-2">
              {t('TUTORIAL_070_MOB_TEXT_2')}
            </div>
            <div className="d-flex justify-content-center mt-5">
              <img
                height={150}
                src={'/slides/mobile/slide6-mobile.svg'}
                alt="Slide2"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="TitleSlideMobileWithBorder">{t('LOGIN')}</div>
            <div className="mt-3 mb-3 text-tutorial-mobile">
              {t('TUTORIAL_071_MOB_TEXT')}
            </div>
            <div className="d-flex justify-content-center mt-5">
              <img src={'/slides/mobile/slide7-mobile.svg'} alt="Slide2" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="TitleSlideMobileWithBorder">
              {t('TUTORIAL_072_MOB_TITLE')}
            </div>
            <div className="mt-3 mb-3 text-tutorial-mobile">
              {t('TUTORIAL_072_MOB_TEXT')}
            </div>
            <div className="d-flex justify-content-center mt-5">
              <img src={'/slides/mobile/slide8-mobile.svg'} alt="Slide2" />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="TitleSlideMobileWithBorder">
              {t('TUTORIAL_080_ALL_TITLE')}
            </div>
            <div className="mt-3 mb-3 text-tutorial-mobile">
              {t('TUTORIAL_080_ALL_TEXT')}
            </div>
            <div className="d-flex justify-content-center mt-5">
              <img
                height={150}
                src={'/slides/mobile/slide9-mobile.svg'}
                alt="Slide2"
              />
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className={'position-relative'}>
          <div className={'SlideMobile'}>
            <div className="d-flex justify-content-center align-items-center h-100 flex-column">
              <div>
                <Logo width={60} />
              </div>
              <div className="mt-4 TitleSlideMobile">{t('GENERIC_WLM')}</div>
              <div className="mt-4 text-tutorial-mobile">
                {t('TUTORIAL_090_ALL_TEXT')}
              </div>
              <div className="mt-5 SubtitleSlideMobile">
                {t('TUTORIAL_CLOSING')}!
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
      <div
        onClick={() => {
          setPresentazione(false)
        }}
        className="button-close-slides-mobile"
      >
        <Close />
      </div>
      <div className={'pagination-container-onboarding'}>
        <ArrowLeftSlideShow
          onClick={() => {
            if (activeSlide > 0) {
              sliderRef.current?.slidePrev()
            }
          }}
          className={classNames('me-3', {
            pointer: activeSlide > 0,
          })}
          fill={
            activeSlide > 0
              ? 'var(--colori-neutri-white)'
              : 'var(--colori-neutri-gray-2)'
          }
        />
        <div className={'current-slide-onboarding'}>{activeSlide + 1} / 11</div>
        <ArrowRightSlideShow
          onClick={() => {
            if (activeSlide < 10) {
              sliderRef.current?.slideNext()
            }
          }}
          className={classNames('ms-3', {
            pointer: activeSlide < 11,
          })}
          fill={
            activeSlide < 10
              ? 'var(--colori-neutri-white)'
              : 'var(--colori-neutri-gray-2)'
          }
        />
      </div>
    </div>
  )
}

export default function Layout({ children }: { children: React.ReactNode }) {
  const [presentazione, setPresentazione] = useState<boolean>(false)
  const [show, setShow] = useState(false)
  const [infoWiki, setInfoWiki] = useState(false)
  const [modalLang, setModalLang] = useState(false)
  const [modalPaese, setModalPaese] = useState(false)
  const [legend, setLegend] = useState(false)
  const [profileOpen, setProfileOpen] = useState(false)
  const [modalCredits, setModalCredits] = useState(false)

  const { donationModal, setDonationModal } = useDonationContext()
  const activeGeocontext = getActiveGeocontext()
  const { i18n, t } = useTranslation()

  const donationText = useMemo(() => {
    if (!activeGeocontext) return ''
    if (
      activeGeocontext.donation_texts[i18n.language] &&
      activeGeocontext.donation_texts[i18n.language] !== ''
    ) {
      return activeGeocontext.donation_texts[i18n.language]
    }
    if (activeGeocontext.fallback_language_donation_intro) {
      const fallbackCode =
        activeGeocontext.fallback_language_donation_intro.code
      if (
        activeGeocontext.donation_texts[fallbackCode] &&
        activeGeocontext.donation_texts[fallbackCode] !== ''
      ) {
        return activeGeocontext.donation_texts[fallbackCode]
      }
    }
  }, [activeGeocontext, i18n.language])

  useEffect(() => {
    if (!localStorage.getItem('presentazione')) {
      setPresentazione(true)
      localStorage.setItem('presentazione', 'true')
    }
  }, [])
  return (
    <div className="h-100 w-100">
      {presentazione && (
        <SlidesPresentazioneMobile setPresentazione={setPresentazione} />
      )}

      <Topbar
        setShow={setShow}
        show={show}
        infoWiki={infoWiki}
        setInfoWiki={setInfoWiki}
        presentazione={presentazione}
        setPresentazione={setPresentazione}
        modalPaese={modalPaese}
        setModalPaese={setModalPaese}
        modalLang={modalLang}
        setModalLang={setModalLang}
      />

      <div className="block-content">{children}</div>
      <BottomNavigation setLegend={setLegend} legend={legend} />
      {show && (
        <Menu
          setMenu={setShow}
          setInfoWiki={setInfoWiki}
          setModalLang={setModalLang}
          setPresentazione={setPresentazione}
          setModalPaese={setModalPaese}
          setProfileOpen={setProfileOpen}
          setModalCredits={setModalCredits}
        />
      )}
      {legend && <Legend legend={legend} setLegend={setLegend} />}
      {profileOpen && (
        <Profile
          isOpenProfile={profileOpen}
          setIsOpenProfile={setProfileOpen}
        />
      )}
      {modalCredits && (
        <Credits openCredits={modalCredits} setOpenCredits={setModalCredits} />
      )}
      {donationModal && activeGeocontext?.enable_donations_text && (
        <Modal
          show={donationModal}
          onHide={() => setDonationModal(false)}
          className="modal-donation"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{t('MENU_DONATIONS')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="">
              <div className="">
                <div
                  dangerouslySetInnerHTML={{
                    __html: donationText || '',
                  }}
                ></div>
                <p>
                  <a
                    className="btn-donate text-decoration-none"
                    href={activeGeocontext.donations_link}
                    target="_blank"
                  >
                    {t('DON_WIN_CMD_DONATE')}
                  </a>
                </p>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  )
}
